import React from "react";
import OmitType from "customTypes/OmitType";
import Rotate, { IRotateProps } from "./Rotate";

function randomIntFromInterval(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

interface IProps extends OmitType<IRotateProps, "amount"> {
    min?: number;
    max: number;
    direction?: "clockwise" | "anticlockwise" | "both";
}

export default function RandomRotate(props: IProps) {
    const { min = 0, max, direction = "both", ...rest } = props;

    const absMin = Math.abs(min);
    const absMax = Math.abs(max);

    if (absMax < absMin)
        throw new Error(`RandomRotate: max (${absMax}) must be greater than min (${absMin})`);

    let randomRotateAmount = randomIntFromInterval(absMin, absMax);

    if (direction === "anticlockwise") randomRotateAmount = -randomRotateAmount;

    if (direction === "both")
        randomRotateAmount =
            randomIntFromInterval(0, 1) < 0.5 ? randomRotateAmount : -randomRotateAmount;

    return <Rotate amount={randomRotateAmount} {...rest} />;
}
